<template>
   <vue-final-modal
      v-model="showTitle" 
      classes="modal-container"
      content-class="show-title-modal-content"
      @before-open="beforeOpen()"
      :click-to-close="false"
      drag-selector=".drug-area"
      :drag="true"
      >
            <!--
      @click-outside="$emit('cancel')"
            -->
      <button 
         id="prime"
         type="button"
         class="modal__close btn btn-sm" 
         :tabindex="tabIndexNumber(2)" 
         @click="$emit('cancel')"
         >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__title tx-cl-white row row-cols-auto">
         <card-rectangle :rectangleCard="cardType" class="col mt-1"/>
         <div class="col pe-1">Título de la tarjeta</div>
      </span>
      <div class="show-title p-0 mt-1 border-top border-bottom">
         <div class="container">
            <div :tabindex="tabIndexNumber(1)" onfocus="document.getElementById('final').focus()"></div>
            <!--
            <pre>{{ v310Object }}</pre>
            <div class="drug-area bg-light rounded my-2 ttl p-1"> <b>{{ title }}</b> </div>
                     <h6 class="text-break"><b><div v-html="content.title"></div></b></h6>
            -->
            <div class="drug-area bg-light rounded my-2 ttl p-1"> <b><div v-html="htmlTitle"></div></b> </div>
         </div>
      </div>
            <div class="row p-0 justify-content-between mx-0">
               <user-circle :circleUser="myCircle" class="col-2 mt-2"/>
               <div class="d-flex justify-content-end pt-2 px-0 col-10">
                  <button type="button" 
                        :tabindex="tabIndexNumber(3)" 
                        class="btn btn-outline-light btn-sm me-1" 
                        @click="$emit('update')"
                        >
                     {{textButton}}
                  </button>
                  <button type="button" 
                        id="final"
                        :tabindex="tabIndexNumber(4)" 
                        class="btn btn-outline-light btn-sm me-1" 
                        @click="$emit('cancel')"
                        >
                     Volver
                  </button>
                  <div :tabindex="tabIndexNumber(5)" onfocus="document.getElementById('prime').focus()"></div>
               </div>
            </div>
   </vue-final-modal>
</template>

<script>


import { VueFinalModal } from 'vue-final-modal'
import { ref, computed } from 'vue';
import { useStore } from 'vuex'

import WspService from '../../workSpace.service';

import UserCircle from '../../../../components/UserCircle.vue';
import CardRectangle from '../CardRectangle.vue';

export default {

   components: {
      UserCircle,
      VueFinalModal,
      CardRectangle
   },

   props: {
      cardType: Object,
      title: String,
      contentId: Number
   },

   emits: [ 'cancel', 'update' ],

   //setup(props, { emit }) {
   setup( props ) {

      const initialTabIndex = ref(150)
      const showTitle = ref(true)
      const myCircle = ref({})
      const store = useStore()

      const htmlTitle = computed(() => {
         return WspService.htmlSeparator( props.title );
      })

      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })

      const textButton = ref('Generar Tarjeta')

      function beforeOpen() {
         
         textButton.value = 'Generar Tarjeta'
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            myCircle.value = response.data
            if ( props.contentId > 0 ) {
               textButton.value = 'Guardar'
            }
         })
         .catch(error => {
            console.log(error);
         })
      }
      /*
      function sendSelect( index ) {
         emit( 'selected', index)
         nextTick(() => {
            emit('cancel')
         })
      }
      */
      function tabIndexNumber( value ) {
         return initialTabIndex.value + value
      }

      
      return {
         beforeOpen,
         htmlTitle,
         myCircle,
         showTitle,
         tabIndexNumber, textButton
      }
   }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
::v-deep(.show-title-modal-content) {
  /*
  width: 350px;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 300px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.show-title {
   background-color: #9E9E9E ;
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.tx-cl-white {
   color: white;
}
td {
   height: 1.5rem;   
}
.tj-foot-cell {
   cursor: pointer;
}
.tj-foot-cell:hover {
   background-color: darkgrey;
}
.ttl {
   color: darkslategray;
}
</style>
